// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import DashboardPlus from '../components/DashboardPlus';
import {actions as DashboardAction} from '../duck';
import {actions as OrderActions} from '../../orders/duck';
import type {RootState} from '../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    user: state.auth.user,
    store: state.store.store,
    pageViews: state.dashboard.pageViews,
    orderData: state.dashboard.orderData,
    productsCount: state.dashboard.productsCount,
    ordersCount: state.orders.ordersCount,
    productCategoryData: state.dashboard.productCategoryData,
    productData: state.dashboard.productData,
    salesData: state.dashboard.salesData,
    viewsData: state.dashboard.viewsData,
    mostSeenProducts: state.dashboard.mostSeenProducts,
    currency: state.currency.currency,
    dateIni: state.dashboard.dateIni,
    errorAnalyticsFetched: state.dashboard.error,
    resellerInformation: state.ui.resellerInformation,
    isFetchingResellerInformation: state.ui.isFetchingResellerInformation,
    points: state.referral.availablePoints,
    subscription: state.tiersList.currentSubscription,
    subscriptionSetting: state.accountConfig.subscriptionSetting,
    orderAmount: state.dashboard.orderAmount,
    averageTicket: state.dashboard.averageTicket,
    isFetchingCustomers: state.dashboard.isFetchingCustomers,
    customers: state.dashboard.customers,
    isFetchingLessStockProducts: state.dashboard.isFetchingLessStockProducts,
    lessStockProducts: state.dashboard.lessStockProducts,
    isFetchingPromotionsSales: state.dashboard.isFetchingPromotionsSales,
    isFetchingViewsData: state.dashboard.isFetchingViewsData,
    isFetchingSummaryProducts: state.dashboard.isFetchingSummaryProducts,
    promotionSales: state.dashboard.promotionSales,
    isFetchingFlaglessProducts: state.dashboard.isFetchingFlaglessProducts,
    flagLessStockProducts: state.dashboard.flagLessStockProducts,
    dueInformation: state.tiersList.dueInformation,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators({...DashboardAction, ...OrderActions}, dispatch)
)(DashboardPlus);
